import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const issueAppEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() =>
			import(/* webpackChunkName: "async-issue-app-entrypoint" */ './issue-app.tsx').then(
				(module) => module.IssueAppEntrypoint,
			),
		{ entryFsSsrLiftImportToModule: false },
	),
	getPreloadProps: () => ({}),
});
